import { ifNotAuthenticated } from "@/utils/functions";

import Operations from "@/views/historicalPlans/operations/Operations.vue";
import OperationAdd from "@/views/historicalPlans/operations/OperationAdd.vue";
import OperationEdit from "@/views/historicalPlans/operations/OperationEdit.vue";

const Routes = [
  {
    path: "operations",
    name: "Operations",
    component: Operations,
    beforeEnter: ifNotAuthenticated,
    props(route) {
      return route.params || {};
    },
  },
  {
    path: "add-operation",
    name: "OperationAdd",
    component: OperationAdd,
    beforeEnter: ifNotAuthenticated,
    props(route) {
      return route.params || {};
    },
  },
  {
    path: "edit-operation",
    name: "OperationEdit",
    component: OperationEdit,
    beforeEnter: ifNotAuthenticated,
    props(route) {
      return route.params || {};
    },
  },
];

export default Routes;
